/*
 * App Configuration File
 * Put environment-specific global variables in this file.
 *
 * In general, if you put an variable here, you will want to
 * make sure to put an equivalent variable in all three places:
 * dev.js, stage.js & prod.js
 *
 */
(function (angular) {
  'use strict';

  try {
    angular.module('risevision.common.config');
  } catch (err) {
    angular.module('risevision.common.config', []);
  }

  angular.module('risevision.common.config')
    .value('environment', {
      CORE_URL: 'https://rvacore-test.appspot.com/_ah/api',
      STORE_ENDPOINT_URL: 'https://store-dot-rvacore-test.appspot.com/_ah/api',
      STORE_SERVER_URL: 'https://store-dot-rvacore-test.appspot.com/',
      STORAGE_ENDPOINT_URL: 'https://storage-dot-rvacore-test.appspot.com/_ah/api',
      APPS_URL: 'https://apps-stage-0.risevision.com',
      ENV_NAME: 'STAGE',
      // Google Tag Manager Live environment
      TAG_MANAGER_CONTAINER_ID: 'GTM-MMTK3JH',
      TAG_MANAGER_AUTH: 'Ry3lxk_Xrlx2qhbXmLA-Pg',
      TAG_MANAGER_ENV: 'env-254',
      HUBSPOT_ACCOUNT: '2939619'
    })
    .value('ENABLE_EXTERNAL_LOGGING', true);
})(angular);
